<template>
<div>
    <v-snackbar bottom right :timeout="5000" v-model="snackbar.active" color="white" class="grey--text">
        <v-icon :class="`${snackbar.action}--text mr-4`" x-large v-text="snackbar.action == 'success' ? 'mdi-checkbox-marked-circle-outline' : 'mdi-close-circle-outline'"></v-icon>
        <span :class="`grey--text text--darken-1 text-capitalize body-2`">{{snackbar.message}}</span>
        <v-btn icon color="grey" text @click="snackbar.active = false">
            <v-icon>mdi-close</v-icon>
        </v-btn>
    </v-snackbar>
    <v-app-bar class="box-shadow-custom-1" color="white" app>
        <v-app-bar-nav-icon v-if="!drawer" @click.stop="drawer = !drawer" />
        <v-toolbar-title v-if="title != 'Logs'">{{title}}</v-toolbar-title>
        <v-breadcrumbs class="cus-breadcrumb" v-if="title == 'Logs'" :items="bread" large>
            <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
            </template>
        </v-breadcrumbs>
        <v-spacer></v-spacer>
        <div style="position: relative;display: flex;align-items: center;justify-content: center;height: 60px;" v-if="countDown != 'EXPIRED'">
            <div>
                <div style="font-size: 10px;font-weight: 900;background: #029be5;padding: 0px 5px;color: #fff;border: 1px solid #000;border-radius: 10px;width: max-content;position: absolute;top: -1px;z-index: 1;">OFFER ENDS IN</div>
                <div style="display: flex;justify-content: flex-end;margin-right: 10px;background: rgb(236 236 236);height: 42px;padding: 6px 16px;border-radius: 10px;line-height: 16px;align-items: center;border: 1px solid #c0c0c0;">
                    <div style="margin-top: 4px;text-align: center;line-height: 11px;"><span style="font-size: 20px;font-weight: 900;">{{countDown.hours}}</span><br><small>Hours</small></div>
                    <div style="font-size: 34px;padding: 10px;color: #888;">:</div>
                    <div style="margin-top: 4px;text-align: center;line-height: 11px;"><span style="font-size: 20px;font-weight: 900;">{{countDown.minutes}}</span><br><small>Minutes</small></div>
                    <div style="font-size: 34px;padding: 10px;color: #888;">:</div>
                    <div style="margin-top: 4px;text-align: center;line-height: 11px;"><span style="font-size: 20px;font-weight: 900;" class="primary--text">{{countDown.seconds}}</span><br><small>seconds</small></div>
                </div>
            </div>
        </div>
        <v-chip v-if="userAccount.credit.used >= userAccount.credit.total" class="ma-2 px-6 font-weight-bold" small rounded color="warning" dark>
            <v-icon small left>mdi-alert-outline</v-icon> Test credits exhausted
        </v-chip>
        <span v-if="onResult">
            <div class="mr-3">
                <v-tooltip v-model="show" bottom min-width="250" height="300">
                    <template v-slot:activator="{ on }">
                        <div class="nav-circular" v-on="on">
                            <div class="nav-circular-item color-blue pa-2" style="font-size: 13px;font-weight: bolder;">
                                {{numeral(userAccount.credit.used)}} <br>
                            </div>
                            <span style="white-space: nowrap; font-size: 12px;">Credits used</span>
                        </div>
                    </template>
                    <span>
                        <v-row align="center" class="px-4 pt-2">
                            <v-icon small left color="white">mdi-credit-card</v-icon> <span class="d-none d-sm-block mr-1">Credits:</span> {{numeral1(userAccount.credit.used)}} out of {{numeral1(userAccount.credit.total)}} 
                        </v-row>
                        <v-row align="center" class="px-4 pb-2">
                            <v-icon small left color="white">mdi-chart-donut</v-icon> <span class="d-none d-sm-block mr-1"></span> ({{Percentage(userAccount.credit.used, userAccount.credit.total)}} Used) <span class="headline ma-1"></span>
                        </v-row> 
                    </span>
                </v-tooltip>
            </div>
        </span>
        <div class="nav-circular px-3" style="cursor: pointer;" @click="plansPage">
            <div class="nav-circular-item color-yellow">
                {{numeral(foreCastCredit)}} <br>
            </div>
            <span style="white-space: nowrap; font-size: 10px; line-height: 1;">credit needed <br /> Upgrade Now</span>
        </div>
        <div v-if="userAccount.credit.used < 1000" class="d-flex flex-column" style="align-items: center; justify-content: center; margin-right: 74px;">
            <img src="/images/medal.png" alt="Certified" width="40">
            <small style="line-height: 1; font-size: 10px;" class="px-2">Finish 1000 tests</small>
            <div class="badge-custom"><small style="font-size: 10px;" class="">Get your badge</small></div>
        </div>
        <span>
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <div class="d-flex">
                        <v-avatar class="my-3 mr-3" size="38" v-on="on">
                            <img :src="imageUser" :alt="userAccount.name">
                        </v-avatar>
                        <img v-if="userAccount.credit.used > 1000" :style="`position: absolute; top: 30px; right: 16px; z-index: 1; width: 25px;`" src="/images/medal.png" alt="Certified" width="40">
                    </div>
                </template>
                <v-list dense class="pt-0">
                    <v-list-item>
                        <v-list-item-avatar>
                            <img :src="imageUser" :alt="userAccount.name">
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>{{userAccount.name}}</v-list-item-title>
                            <v-list-item-subtitle>{{userAccount.company}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item to="/profile/account">
                        <v-list-item-icon class="mr-4">
                            <v-icon>mdi-account</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="subtitle-1">Account</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="logOut">
                        <v-list-item-icon class="mr-4">
                            <v-icon>mdi-logout</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="subtitle-1">Logout</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-menu>
        </span>
        <!-- <span>
            <LoginRegister class="ml-1" />
        </span> -->
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" app color="primary" dark style="height: 111vh">
        <v-list-item class="px-0 pr-4 py-3">
            <v-list-item-content class="pt-0">
                <router-link to="/" style="text-decoration: none;">
                    <v-list-item-title class="headline white--text pa-4 pb-0 font-weight-black text-center">
                        <img width="100%" src="/images/logo.png" alt="logo">
                    </v-list-item-title>
                </router-link>
            </v-list-item-content>
        </v-list-item>
        <v-list dense class="primary">
            <v-list-item v-for="(item, index) in items" :key="index" :to="item.route">
                <v-list-item-icon class="mr-3">
                    <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title class="subtitle-1">{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <template v-slot:append>
            <v-list-item @click.stop="drawer = !drawer">
                <v-list-item-icon class="mr-3">
                    <v-icon>mdi-chevron-left</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title class="subtitle-1">Collapse</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
    </v-navigation-drawer>
</div>
</template>

<script>
import {
    mapGetters,
    mapMutations,
    mapActions
} from 'vuex'
import Gravatar from 'gravatar'
import numeral from 'numeral'
import moment from 'moment'
import * as easings from 'vuetify/es5/services/goto/easing-patterns'
export default {
    components: {
        LoginRegister: () => import('../Auth/Dialog')
    },
    data() {
        return {
            date: [moment(new Date()).subtract(30, 'days').format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD")],
            show: false,
            bread: [
                {
                    text: 'Auto Test Manage',
                    disabled: false,
                    to: '/auto-tests'
                },
                {
                    text: 'Logs',
                    disabled: true,
                    to: 'Logs'
                },
            ],
            title: '',
            drawer: true,
            miniVariant: true,
            imageUser: '',
            onResult: true,
            items: [{
                    title: 'Link Test',
                    icon: 'mdi-link',
                    route: "/"
                },
                {
                    title: 'Auto Test',
                    icon: 'mdi-transit-connection-variant',
                    route: "/auto-tests"
                }, 
                {
                    title: 'Account',
                    icon: 'mdi-account',
                    route: "/profile/account"
                }, {
                    title: 'Usage',
                    icon: 'mdi-chart-areaspline',
                    route: "/usage"
                },
                {
                    title: 'Billing & Plans',
                    icon: 'mdi-currency-usd',
                    route: "/details/info"
                }, {
                    title: 'History',
                    icon: 'mdi-history',
                    route: "/history"
                },
                {
                    title: 'Export Test History',
                    icon: 'mdi-database-export-outline',
                    route: "/export-history"
                }, 
                {
                    title: 'API',
                    icon: 'mdi-api',
                    route: "/api"
                }
            ],
            type: 'selector',
            selector: '#plan',
            duration: 1000,
            offset: 40,
            foreCastCredit: 0,
            easing: 'easeInOutCubic',
            easings: Object.keys(easings),
            countDown: 'EXPIRED'
        }
    },
    computed: {
        ...mapGetters(['ifLoged', 'userAccount', 'snackbar', 'usageCredit']),
        target() {
            const value = this[this.type]
            if (!isNaN(value)) return Number(value)
            else return value
        },
        options() {
            return {
                duration: this.duration,
                offset: this.offset,
                easing: this.easing,
            }
        }
    },
    async mounted() {
        this.foreCastCredit = await this.getForecastCredit()
        this.$watch(() => {
            this.getUsage()
            this.title = this.$route.meta.title
            this.isLogIn()
        })
        if (localStorage.getItem('userToken')) {
            this.UserAccount()
        }
        this.isLogin()
        if (this.$router.history.current.meta.guest != undefined) {
            let data = {
                success: true
            }
            this.status_success(data)
            this.onResult = false
        }
    },
    created() {
        this.Gimage()
        this.$watch(() => {
            this.$root.$on('LogChange', () => {
                this.Gimage()
            })
        })
        this.timeout();
    },
    methods: {
        ...mapMutations(['isLogin', 'isLogOut', 'status_success', 'UserAccount', 'getUsage']),
        ...mapActions(['GetResponse', 'TrackEvents']),
        async logOut() {
            this.TrackEvents({event_name: 'logout'});
            await this.isLogOut()
            window.location = 'https://offersoptimize.com/';
        },
        plansPage() {
            this.$router.push('/plans')
        },
        async isLogIn() {
             try {
                let url = '/internal/v2/usage-stats'
                const data = (await this.GetResponse(url)).data
            } catch (err) {
                err.response.data.errors.map(res => {
                    if (res.code == '101' || res.code == '102' || res.code == '103' || res.code == '104') {
                        localStorage.removeItem('userToken');
                    }
                })
            }
        },
        async getUsage(){
            try {
                let url = '/internal/v2/usage-stats'
                const data = (await this.GetResponse(url)).data
                if (data.success) {
                    localStorage.setItem("account", JSON.stringify(data.data.account))
                    localStorage.setItem("user", JSON.stringify(data.data.user))
                    localStorage.setItem("credit", JSON.stringify(data.data.credit))
                    this.UserAccount()
                } else {
                    let dataMsg = { success: true, message: data.message, action: 'error' }
                    this.SnackbarSuccess(dataMsg)
                }
            } catch (err) {
               let dataMsg = { success: true, message: err.response.data.errors[0].message, action: 'error' }
                this.SnackbarSuccess(dataMsg)
            }
        },
        numeral(item){
            return numeral(item).format('0 a')
        },
        numeral1(item){
            return numeral(item).format('0,0')
        },
        Percentage(use, total){
            return numeral(use/total*100).format('0,0.0') + '%'
        },
        Gimage() {
            var user = JSON.parse(localStorage.getItem('user'))
            if (user) {
                this.imageUser = Gravatar.url(user.email);
            }
        },
        async getForecastCredit() {
            let startDate = moment(new Date()).subtract(180, 'days').format("YYYY-MM-DD"),
                endDate = this.date[1],
                url = `/internal/v2/usage-stats?start=${startDate}&end=${endDate}`
            const data = (await this.GetResponse(url))
            let stats = data.data.data.stats
            let creditUsed = data.data.data.credit.used || 0
            var count = 0
            Object.keys(stats).forEach(function(key) {
                count += parseInt(stats[key])
            });
            return parseInt(creditUsed) + parseInt(count/6);
        },
        timeout() {
            var self = this;
            setTimeout(function() {
                const end = moment(self.userAccount.user.created).add(1, 'day').format("MMM D YYYY, HH:mm:ss");
                var countDownDate = new Date(end).getTime();
                var x = setInterval(function() {
                    var now = new Date().getTime();
                    var distance = countDownDate - now;
                    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
                    self.countDown = {
                        hours,
                        minutes,
                        seconds
                    }
                    if (distance < 0) {
                        clearInterval(x);
                        self.countDown = "EXPIRED";
                    }
                }, 1000);
            }, 1000);
        }
    }
}
</script>

<style>
.color-blue {
    background: #039be5;
}
.color-yellow {
    background: #fb8c00;
}
.nav-circular {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.nav-circular-item {
    color: white;
    text-align: center;
    line-height: 1;
    border: none;
    border-radius: 50px;
    height: 40px;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    word-break: break-all;
}
.badge-custom {
    position: absolute;
    right: 74px;
    top: 6px;
    background-color: rgb(3, 155, 229) !important;
    border-color: rgb(3, 155, 229) !important;
    color: white;
    padding: 0px;
    height: 19px;
    border-radius: 32px;
    width: 88px;
    text-align: center;
    display: flex;
    font-weight: 800;
    align-items: center;
    justify-content: center;
}
.v-application ul, .v-application ol{
    padding-left: 0px;
}
.v-breadcrumbs__item{
    font-size: 20px !important;
}
.profile-logo {
    float: right;
    margin-top: -49px;
    width: min-content;
}

.box-shadow {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .02)
}

@media only screen and (max-width: 600px) {
    .m-width {
        width: auto !important;
    }
}

.v-snack--bottom {
    bottom: 30px !important;
}

.v-snack--right {
    right: 30px !important;
}

.cool-link {
    display: inline-block;
    color: #777 !important;
    text-decoration: none;
    padding: 5px 10px;
    font-size: 15px;
    transition: all .5s;
    text-align: center;
    font-weight: bolder;
    font-family: sans-serif;
}

.cool-link:hover {
    color: #1976d2 !important;
}

.vertical-bottom {
    vertical-align: bottom;
}

.cool-link.router-link-exact-active.router-link-active {
    color: #1976d2 !important;
}
</style>
